// extracted by mini-css-extract-plugin
module.exports = {"grad":"SoLieuBieuDo_grad__3T6Aj"};